import _CampaignOutlined from "@mui/icons-material/CampaignOutlined";
var _templateObject, _templateObject2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import { Tooltip, Fab } from '@mui/material';
import styled from 'styled-components';
import { COLORS } from '@fupa/fupa-uikit';
import { initSentryUserFeedback } from 'app/hooks/useSentryUserFeedback';
const Container = styled.div.withConfig({
  componentId: "sc-jcnk1e-0"
})(["z-index:", ";bottom:11rem;right:0;position:fixed;display:flex;align-items:flex-end;justify-content:flex-end;", " ", ";"], props => props.theme.zIndexFab, props => props.theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    bottom: 7.5rem;\n  "]))), props => props.theme.desktopLayoutWithFab(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-left: ", "px;\n    right: unset;\n  "])), props => props.theme.desktopContentWidth));
const UserFeedbackFab = props => {
  initSentryUserFeedback();
  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    "data-sentry-element": "Container",
    "data-sentry-component": "UserFeedbackFab",
    "data-sentry-source-file": "UserFeedbackFab.tsx"
  }), /*#__PURE__*/React.createElement(Tooltip, {
    title: "Feedback geben",
    placement: "right",
    "data-sentry-element": "Tooltip",
    "data-sentry-source-file": "UserFeedbackFab.tsx"
  }, /*#__PURE__*/React.createElement(Fab, {
    id: 'fupa-feedback-btn',
    sx: {
      color: COLORS.darkerGrey,
      backgroundColor: COLORS.white,
      margin: '1rem'
    },
    size: "small",
    "aria-label": "Feedback geben",
    "data-sentry-element": "Fab",
    "data-sentry-source-file": "UserFeedbackFab.tsx"
  }, /*#__PURE__*/React.createElement(_CampaignOutlined, {
    "data-sentry-element": "CampaignOutlined",
    "data-sentry-source-file": "UserFeedbackFab.tsx"
  }))));
};
export default UserFeedbackFab;